export default __webpack_public_path__ + "static/media/Rectangle 59.0abe1a28.png";